import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import createCache from "@emotion/cache";
import Grid from "@mui/material/Unstable_Grid2";
import { theme } from "./theme";


const cacheRTL = createCache({
    key: "muirtl",
});

const MainLayout = ({ children }) => {
    return (
        <CacheProvider value={cacheRTL}>
            <ThemeProvider theme={theme}>
                <HelmetProvider>
                    <Helmet>
                        <title> Project Management</title>
                    </Helmet>
                    <Grid container sx={{ height: "100vh" }} >
                        {children}
                    </Grid>
                </HelmetProvider>
            </ThemeProvider>
        </CacheProvider>
    );
};

export default MainLayout;
